"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filteredCopy = exports.optimizationWhitelist = void 0;
/**
 * The mere existence of a property in this object represents a positive read permission.
 * If the property’s value is `true`, the write permission is positive as well.
 */
exports.optimizationWhitelist = {
    identifier: false,
    alias: false,
    // This is a special one, there is no property called `meta`
    // but we need the next four properties after this one for
    // functional reasons without exposing them to the user.
    meta: false,
    name: false,
    status: false,
    valid_from_timestamp: false,
    asset_type: false,
    grid_connection_capacity: false,
    grid_connection_capacity_in: false,
    grid_connection_capacity_out: false,
    opt_run_schedule: false,
    horizon_mode: true,
    storage: true,
    volume_capacity: true,
    lower_soc_limit: true,
    upper_soc_limit: true,
    x_methane: true,
    soc_initialization_mode: true,
    fill_level_entry: true,
    fixed_initial_fill_level: true,
    fill_level: true,
    measured_at: true,
    end_level_tolerance: false,
    fixed_weekly_fill_level_config: true,
    //the following parameters are children of fixed_weekly_fill_level_config, their permissions are subjected to the parent
    //fill_level: true - this is a duplicate, it is listed here for coherence
    time: true,
    weekday: true,
    gas_production: true,
    target_power_electric: true,
    conversion_efficiency: true,
    target_power_schedule_constraints: true,
    motors: true,
    p_min: true,
    p_max: true,
    efficiency: true,
    minimal_power_conversion_efficiency: true,
    schedule_constraints: true,
    on_time_min: true,
    on_time_max: true,
    off_time_min: true,
    off_time_max: true,
    daily_starts_min: true,
    daily_starts_max: true,
    weekly_starts_min: true,
    weekly_starts_max: true,
    daily_on_time_min: true,
    daily_on_time_max: true,
    start_costs: true,
    additional_start_costs: true,
    self_consumption: true,
    pv: false,
    forecast_id: false,
    installed_power: false,
    accepted_power_deviation: false,
    eeg_subsidy_parameters: false,
    eeg_auction_value: false,
    negative_hours_threshold: false,
    batteries: false,
    battery: false,
    device_number: false,
    power_charge: false,
    power_discharge: false,
    energy_capacity: false,
    nominal_capacity: false,
    efficiency_in: false,
    efficiency_out: false,
    charge_price: false,
    costs_per_full_cycle: false,
    storage_max: false,
    storage_min: false,
    accepted_capacity_deviation: false,
    cycle_per_year: false,
    cycle_per_day: false,
    prequalified_power: false,
    fcr_storage_reserve_time: false,
    afrr_activation_reserve_time_neg: false,
    afrr_activation_reserve_time_pos: false,
    peak_windows: false,
    // CoLocation
    energy_efficiency_in: false,
    energy_efficiency_out: false,
    use_dynamic_power_limits: false,
    //Automated parameters
    enable_live_parameter: false,
    default_value: false,
    live_value: false,
};
function filteredCopy(object) {
    if (Array.isArray(object)) {
        // Array items are not filtered, they get passed as they are
        return object;
    }
    else if (object != null && typeof object === 'object') {
        return Object.entries(object)
            .filter(([key]) => key in exports.optimizationWhitelist ||
            /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/.test(key))
            .reduce((previous, [key, value]) => ({ ...previous, [key]: filteredCopy(value) }), {});
    }
    return object;
}
exports.filteredCopy = filteredCopy;
